import Appsignal from '@appsignal/javascript';
import { plugin as pluginWindowEvents } from '@appsignal/plugin-window-events';
import { plugin as pluginPathDecorator } from '@appsignal/plugin-path-decorator';
import { errorHandler as vueErrorHandler } from '@appsignal/vue';
import { APPSIGNAL_NAMESPACES } from './constants';

// Appsignal singleton
let appsignalInstance = null;
const AppsignalSingleton = function AppsignalSingleton(key) {
  if (!appsignalInstance) {
    appsignalInstance = new Appsignal({ key });
    appsignalInstance.use(pluginWindowEvents());
    appsignalInstance.use(pluginPathDecorator());
  }
  return appsignalInstance;
};

const getAppsignal = ($config) => {
  const key = $config.public.APPSIGNAL_PUSH_API_KEY || false;
  return key && AppsignalSingleton(key);
};

const logErrorToConsole = (e) => {
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(e);
  }
};

export const axiosErrorHandler = (appsignal, error) => {
  logErrorToConsole(error);
  const { response } = error;
  const { status, data: responseData } = response;
  const { baseURL, url, method } = response?.config || {};
  const span = appsignal.createSpan();
  span.setError(error);
  span.setTags({ status, baseURL, url, responseData });
  // Will print something like "401 - GET /users/123"
  span.setAction(`${status ? status + ' - ' : ''}${method?.toUpperCase()} ${url}`);
  span.setNamespace(APPSIGNAL_NAMESPACES.AXIOS);
  appsignal.send(span);
};

export default defineNuxtPlugin(() => {
  const { $config, $axios, vueApp } = useNuxtApp();
  const appsignal = getAppsignal($config);

  /** LOG AXIOS ERRORS */
  if (appsignal) {
    $axios.interceptors.response.use(
      (response) => response,
      (error) => axiosErrorHandler(appsignal, error),
    );
  }

  /** LOG VUE ERRORS */
  if (appsignal) {
    vueApp.config.errorHandler = vueErrorHandler(appsignal, vueApp);
  }

  return {
    provide: {
      /** LOG CUSTOM ERRORS */
      logError: ({ error, namespace = APPSIGNAL_NAMESPACES.DEFAULT, action = '', tags = {} }) => {
        if (appsignal) {
          let err = error;
          if (!(error instanceof Error)) {
            err = new Error(error);
          }
          const span = appsignal.createSpan();
          span.setTags(tags).setError(err).setAction(action).setNamespace(namespace);
          appsignal.send(span);
        } else {
          logErrorToConsole(error);
        }
      },
    },
  };
});
